(function(){
  'use strict';
  var choices={
    contact:{title:'Compare the contact surface first',copy:'Look at the exact brush head: its material, softness and shape. IVORI One offers soft silicone bristles; a soft or extra-soft conventional head offers a different texture. Check what is included in the box and what replacement you would buy.',link:'#p5-features',label:'Explore the four comfort checks ↓'},
    vibration:{title:'Look for the powered feel you prefer',copy:'Compare a clearly specified gentle programme or lower intensity. If you want no motor vibration at all, start with a suitable manual brush. A softer head and a lower motor setting answer different questions.',link:'#p5-shortlist',label:'Compare the named options ↓'},
    pressure:{title:'Put verified pressure feedback first',copy:'Look for a model that explicitly alerts you when you press too hard, then read how its signal works. A soft mode is not the same feature as a pressure sensor. Ask your dental team to help with technique if pressure is a recurring concern.',link:'#p5-scenarios',label:'See the pressure-focused buying scenario ↓'},
    fit:{title:'Make comfortable placement a priority',copy:'For a wraparound mouthpiece, check its adult sizing and positioning guidance before choosing. It should sit as directed without forcing or pinching. Bring dental-work or fit questions to the manufacturer and your dental professional.',link:'#p5-one',label:'Look closely at the One mouthpiece ↓'}
  };
  function init(){
    document.querySelectorAll('[data-p5-chooser]').forEach(function(root){
      if(root.dataset.ready==='true')return;
      var buttons=root.querySelectorAll('[data-goal]');
      var title=root.querySelector('[data-choice-title]');
      var copy=root.querySelector('[data-choice-copy]');
      var link=root.querySelector('[data-choice-link]');
      if(!title||!copy||!link)return;
      buttons.forEach(function(button){
        button.addEventListener('click',function(){
          var choice=choices[button.dataset.goal];
          if(!choice)return;
          buttons.forEach(function(other){other.setAttribute('aria-pressed',other===button?'true':'false');});
          title.textContent=choice.title;
          copy.textContent=choice.copy;
          link.textContent=choice.label;
          link.setAttribute('href',choice.link);
        });
      });
      root.dataset.ready='true';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
